import React from 'react'

const points = [
	'Mobilní aplikace zabírají 56 %, který uživatelé tráví na internetu.',
	'V App Storu se každou minutu stáhne 51 000 aplikací.',
	'Průměrně má uživatel nainstalovaných 36 aplikací.',
	'Poměr mobilního webu vs. mobilní aplikace co do doby strávené na mobilu je 22 % vs. 78 %.',
	'Více než 75 % celosvětových online obchodů se uskuteční přes mobilní zařízení.',
]

const AppBenefitsStatistics = () => {
	return (
		<div className="bg-secondary  text-white">
			<h2 className="mb-12 mt-16 text-center text-3xl font-bold">
				Nenechte si utéct peníze a příležitost.
			</h2>

			<div className="mb-24 flex justify-center">
				<ul className="space-y-2">
					{points.map(point => (
						<BulletPoint text={point} key={point} />
					))}
				</ul>
			</div>
		</div>
	)
}

const BulletPoint = ({ text }: { text: string }) => {
	return (
		<li className="flex gap-4 px-8">
			<img src="img/icons/dot.svg" alt="dot" height={8} width={8} />
			<p className="text-lg">{text}</p>
		</li>
	)
}

export default AppBenefitsStatistics
